// =============================================================================
// dateMonthToString: imput date format (ISOString): "yyyy-MM-ddThh:mm:ss.sssZ"
// =============================================================================
export const dateMonthToString = (isoDate: string, locale: string) => {
  const date = new Date(isoDate);
  return date.toLocaleString(locale, { month: "long" });
};
